import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';

interface Props {
  cut?: keyof typeof bgClipCutClasses | 'no-cut';
  cutSize?: 'xs' | 'md' | 'lg';
  borderColor?: 'gray-dark' | 'blue' | 'gradient-red' | 'pink' | 'transparent';
  borderHoverColor?:
    | 'gray-dark'
    | 'blue'
    | 'gradient-red'
    | 'pink'
    | 'transparent';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UiCardBordered',
  props: {
    cut: { default: undefined },
    cutSize: { default: 'lg' },
    borderColor: { default: 'gray-dark' },
    borderHoverColor: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { cut: keyof typeof bgClipCutClasses | 'no-cut', cutSize: 'xs' | 'md' | 'lg', borderColor: 'gray-dark' | 'blue' | 'gradient-red' | 'pink' | 'transparent', borderHoverColor:
    | 'gray-dark'
    | 'blue'
    | 'gradient-red'
    | 'pink'
    | 'transparent' };

const bgClipCutClasses = {
  left: {
    xs: 'bg-cut-left-xs',
    md: 'bg-cut-left-md',
    lg: 'bg-cut-left-lg',
  },
  right: {
    xs: 'bg-cut-right-xs',
    md: 'bg-cut-right-md',
    lg: 'bg-cut-right-lg',
  },
  'left-right': {
    xs: 'bg-cut-left-right-xs',
    md: 'bg-cut-left-right-md',
    lg: 'bg-cut-left-right-lg',
  },
};


const cutCorner = computed(() => {
  if (!props.cut || props.cut === 'no-cut') return '';

  return bgClipCutClasses[props.cut][props.cutSize];
});

return { __sfc: true,bgClipCutClasses, props, cutCorner }
}

})